import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { appStore, onboardingApiStore } from "@/hooks";
import { TextButton, FlexBox, ListItem } from "@/components/common";

/**
 * Opens the onboarding workflow.
 */

/**
 * A callout button that opens the onboarding workflow.
 */
const __default__ = {
  name: "OnboardingCallout",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

function handleOnboarding(): void {
  onboardingApiStore.handleLoadOnboardingState("open");
}

return (_ctx: any,_cache: any) => {
  return (_unref(appStore).popups.navPanel)
    ? (_openBlock(), _createBlock(_unref(FlexBox), {
        key: 0,
        x: "2",
        t: "3",
        b: "4",
        justify: "center"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TextButton), {
            block: "",
            flat: "",
            icon: "generate-artifacts",
            label: "Generate Docs",
            class: "q-py-sm text-gradient bd-gradient",
            onClick: handleOnboarding
          })
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_unref(ListItem), {
        key: 1,
        to: "",
        title: "Generate Docs",
        icon: "generate-artifacts",
        class: "text-gradient",
        clickable: "",
        tooltip: "Generate Documentation",
        onClick: handleOnboarding
      }))
}
}

})